module.exports = __webpack_public_path__ + "static/img/novice_guide_student_bg.1defa5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/novice_guide_student_bg.png
// module id = zx/T
// module chunks = 2